module.exports = __webpack_public_path__ + "static/img/mask-01.58c487c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/mask-01.jpg
// module id = 276
// module chunks = 1